const CustomFieldComponent = ({
  name,
  value,
  field,
  error,
  onChange,
  customRender,
}) => {
  if (!customRender) return null;
  
  return customRender(value, (newValue) => onChange(name, newValue), field, error);
};

export default CustomFieldComponent;

